// extracted by mini-css-extract-plugin
export default {"profileIdentitiesContainer":"ProfileIdentitiesTab_profileIdentitiesContainer__CKFOf"};